/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/TrendTopic', 'model/TrendTopicReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/TrendTopic'), require('../model/TrendTopicReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.TrendTopicApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.TrendTopic, root.ForStractionServiceApi.TrendTopicReport);
  }
}(this, function(ApiClient, TrendTopic, TrendTopicReport) {
  'use strict';

  /**
   * TrendTopic service.
   * @module api/TrendTopicApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new TrendTopicApi. 
   * @alias module:api/TrendTopicApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the trendTopicAddPut operation.
     * @callback module:api/TrendTopicApi~trendTopicAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/TrendTopic} body 
     * @param {module:api/TrendTopicApi~trendTopicAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.trendTopicAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling trendTopicAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/TrendTopic/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicDeleteGet operation.
     * @callback module:api/TrendTopicApi~trendTopicDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/TrendTopicApi~trendTopicDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.trendTopicDeleteGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicDeleteGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling trendTopicDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/TrendTopic/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicEditAllPut operation.
     * @callback module:api/TrendTopicApi~trendTopicEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/TrendTopic>} body 
     * @param {module:api/TrendTopicApi~trendTopicEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.trendTopicEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling trendTopicEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/TrendTopic/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicEditPut operation.
     * @callback module:api/TrendTopicApi~trendTopicEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/TrendTopic} body 
     * @param {module:api/TrendTopicApi~trendTopicEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.trendTopicEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling trendTopicEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/TrendTopic/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicLoadAllGet operation.
     * @callback module:api/TrendTopicApi~trendTopicLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TrendTopic>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/TrendTopicApi~trendTopicLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TrendTopic>}
     */
    this.trendTopicLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [TrendTopic];

      return this.apiClient.callApi(
        '/TrendTopic/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicLoadReportAllGet operation.
     * @callback module:api/TrendTopicApi~trendTopicLoadReportAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/TrendTopicReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadReportAll
     * @param {String} _4SAPIAppID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxMarketWatchesCount  (default to 0)
     * @param {module:api/TrendTopicApi~trendTopicLoadReportAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/TrendTopicReport>}
     */
    this.trendTopicLoadReportAllGet = function(_4SAPIAppID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicLoadReportAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxMarketWatchesCount': opts['maxMarketWatchesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [TrendTopicReport];

      return this.apiClient.callApi(
        '/TrendTopic/loadReportAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the trendTopicLoadReportGet operation.
     * @callback module:api/TrendTopicApi~trendTopicLoadReportGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/TrendTopicReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadReport
     * @param {String} _4SAPIAppID 
     * @param {Integer} primarykey 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {Integer} opts.maxMarketWatchesCount  (default to 0)
     * @param {module:api/TrendTopicApi~trendTopicLoadReportGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/TrendTopicReport}
     */
    this.trendTopicLoadReportGet = function(_4SAPIAppID, primarykey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling trendTopicLoadReportGet";
      }

      // verify the required parameter 'primarykey' is set
      if (primarykey == undefined || primarykey == null) {
        throw "Missing the required parameter 'primarykey' when calling trendTopicLoadReportGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primarykey': primarykey,
        'maxCommentsCount': opts['maxCommentsCount'],
        'maxMarketWatchesCount': opts['maxMarketWatchesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = TrendTopicReport;

      return this.apiClient.callApi(
        '/TrendTopic/loadReport', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
